var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteWhiteColor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.3335 9.44948C3.3335 8.62209 4.00423 7.95135 4.83162 7.95135H31.7979C32.6253 7.95135 33.296 8.62209 33.296 9.44948C33.296 10.2769 32.6253 10.9476 31.7979 10.9476H4.83162C4.00423 10.9476 3.3335 10.2769 3.3335 9.44948Z",
    fill: "#E8E8E8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.3184 4.95506C14.921 4.95506 14.54 5.11289 14.259 5.39385C13.9781 5.6748 13.8202 6.05586 13.8202 6.45318V7.95131H22.809V6.45318C22.809 6.05586 22.6512 5.6748 22.3702 5.39385C22.0892 5.11289 21.7082 4.95506 21.3109 4.95506H15.3184ZM25.8052 7.95131V6.45318C25.8052 5.2612 25.3317 4.11803 24.4889 3.27517C23.646 2.43232 22.5028 1.9588 21.3109 1.9588H15.3184C14.1264 1.9588 12.9832 2.43232 12.1403 3.27517C11.2975 4.11803 10.824 5.2612 10.824 6.45318V7.95131H7.82772C7.00032 7.95131 6.32959 8.62204 6.32959 9.44944V30.4232C6.32959 31.6152 6.8031 32.7584 7.64596 33.6012C8.48882 34.4441 9.63199 34.9176 10.824 34.9176H25.8052C26.9972 34.9176 28.1404 34.4441 28.9833 33.6012C29.8261 32.7584 30.2996 31.6152 30.2996 30.4232V9.44944C30.2996 8.62204 29.6289 7.95131 28.8015 7.95131H25.8052ZM9.32584 10.9476V30.4232C9.32584 30.8205 9.48368 31.2016 9.76464 31.4826C10.0456 31.7635 10.4266 31.9213 10.824 31.9213H25.8052C26.2026 31.9213 26.5836 31.7635 26.8646 31.4826C27.1455 31.2016 27.3034 30.8205 27.3034 30.4232V10.9476H9.32584Z",
    fill: "#E8E8E8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.3184 15.442C16.1458 15.442 16.8166 16.1127 16.8166 16.9401V25.9288C16.8166 26.7562 16.1458 27.427 15.3184 27.427C14.491 27.427 13.8203 26.7562 13.8203 25.9288V16.9401C13.8203 16.1127 14.491 15.442 15.3184 15.442Z",
    fill: "#E8E8E8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.3109 15.442C22.1383 15.442 22.809 16.1127 22.809 16.9401V25.9288C22.809 26.7562 22.1383 27.427 21.3109 27.427C20.4835 27.427 19.8127 26.7562 19.8127 25.9288V16.9401C19.8127 16.1127 20.4835 15.442 21.3109 15.442Z",
    fill: "#E8E8E8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteWhiteColor);
export default __webpack_public_path__ + "static/media/delete-white-color.89d93b06bdbd8bcd013193b9ed4095d9.svg";
export { ForwardRef as ReactComponent };